import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-rum-wrapper-container',
  templateUrl: './rum-wrapper-container.component.html',
  styleUrls: ['./rum-wrapper-container.component.scss']
})
export class RumWrapperContainerComponent {

  private readonly canGoBack: boolean;
  @Input() isBackButtonVisible: boolean = false;
  @Input() relativeBackButton: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly location: Location
  ) {
    this.canGoBack = !!(this.router.getCurrentNavigation()?.previousNavigation);
  }

  goBack(): void {
    // window.history.back();
    this.router.navigate(['projects']).then(() => true)
  }
}
